import apiClient from "api/axios"
import { toast } from "react-toastify"

// ------------------------
// Helper: Extract filename
// ------------------------
const getFilenameFromHeader = (header, fallback) => {
  if (!header) return fallback
  const match = header.match(/filename="?([^"]+)"?/)
  return match?.[1] || fallback
}

// ------------------------
// Helper: Trigger browser download
// ------------------------
const triggerFileDownload = (blob, filename) => {
  const fileURL = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = fileURL
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(fileURL)
}

// ------------------------
// Generic file download with toast
// ------------------------
export const downloadFile = async (
  url,
  fallbackFilename,
  toastMessage = "Downloading...",
  params = {}
) => {
  const toastId = toast.loading(toastMessage)

  try {
    const response = await apiClient.get(url, { params, responseType: "blob" })

    const filename = getFilenameFromHeader(
      response.headers["content-disposition"],
      fallbackFilename
    )

    triggerFileDownload(
      new Blob([response.data], {
        type: response.headers["content-type"] || "application/pdf",
      }),
      filename
    )

    toast.update(toastId, {
      render: `${filename} downloaded successfully`,
      type: "success",
      isLoading: false,
      autoClose: 3000,
    })

    return { success: true, message: `${filename} downloaded successfully` }
  } catch (error) {
    console.error("Failed to download file:", error)

    toast.update(toastId, {
      render: "Failed to download file",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    })

    throw error
  }
}

// ------------------------
// Vehicle Stock PDF wrapper
// ------------------------
export const downloadVehicleStockPdf = async (params = {}) => {
  return downloadFile(
    "/vehicle-stocks/pdf/download",
    "Vehicle-Stock.pdf",
    "Generating Stock PDF...",
    params
  )
}

// ------------------------
// Vehicle PDF wrapper
// ------------------------
export const downloadVehiclePdf = async stockId => {
  if (!stockId) throw new Error("Stock ID is missing")
  const url = `/vehicle-stocks/${stockId}/pdf/download`
  return downloadFile(url, `Stock-${stockId}.pdf`, "Generating PDF...")
}
